import { render } from "./rockets.vue?vue&type=template&id=5f6443a0"
import script from "./rockets.vue?vue&type=script&lang=js"
export * from "./rockets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__